// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.work-order-main-info {
  display: flex;
}
@media screen and (max-width: 767.98px) {
  .work-order-main-info {
    flex-direction: column;
  }
}
@media screen and (max-width: 767.98px) {
  .work-order-main-info .header-title {
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 767.98px) {
  .work-order-main-info .btn-collapsible {
    display: none;
  }
}

.timeline-table-cells.longer-width {
  width: 250px;
}
@media screen and (max-width: 767.98px) {
  .timeline-table-cells.longer-width {
    width: 150px;
  }
}

.wrapper-timeline-overview {
  display: flex;
}
@media screen and (max-width: 767.98px) {
  .wrapper-timeline-overview {
    flex-direction: column;
  }
}
@media screen and (max-width: 767.98px) {
  .wrapper-timeline-overview .div--spacing {
    display: none;
  }
}

.button-icon, .button-icon:hover {
  background-color: transparent;
  color: #2196F3;
  border: transparent;
  width: fit-content;
  padding: 0;
}

th.table-th-total_time, td.table-td-total_time {
  width: 18em;
}

.sparepart--qty input {
  flex: 0 0 auto;
  width: 50px;
}

.btn-upload ::ng-deep .p-button.p-fileupload-choose {
  padding: 5px;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-icon {
  font-size: 0.7rem;
}
.btn-upload ::ng-deep .p-button.p-fileupload-choose .p-button-label {
  font-size: 0.7rem;
}

.folder-name {
  min-width: 8em;
}

.customer-signature, .engineer-signature {
  border: solid #979797 1px;
}

.signatureList {
  border: solid #979797 1px;
  margin: 10px 0px;
}

.modal-dialog-lg {
  max-width: 700px;
}

.timeline-overview {
  display: flex;
  margin-top: 18px;
}
.timeline-overview > * {
  flex: 1;
}
.timeline-overview .timeline-overview--text {
  text-align: right;
}
.timeline-overview .timeline-overview--value {
  border-top: 2px solid #979797;
  border-bottom: 2px solid #979797;
  text-align: center;
  margin-left: 15px;
}
@media screen and (max-width: 767.98px) {
  .timeline-overview .timeline-overview--value {
    border-top: none;
  }
}

.physical-document-checkbox, .radio-field {
  margin: 5px 10px;
}

.physical-document-checkbox ::ng-deep .p-checkbox .p-checkbox-box {
  background: rgb(180, 180, 180);
}

.file-name-wrapper {
  display: flex;
  flex-wrap: wrap;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
